import React, { useState } from 'react';
import { Button } from 'primereact/button';

import { Filter } from './';
import constants from 'constants/index';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { useTaskActions } from 'modules/TasksV2/context';
import AddNewStage from '../Board/Stage/AddNewStage';

function Header({ currentView, setCurrentView }) {
  const userDetails = useUserDetailsContext();
  const { openAddTask } = useTaskActions();
  const [showAddStageDialog, setShowAddStageDialog] = useState(false);

  return (
    <React.Fragment>
      <GlobalLoader />
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <h1 className="title mb-0">Tasks</h1>
        <div className="d-flex align-items-center mb-2 flex-wrap">
          <div className="mt-3 mt-lg-0">
            {userDetails.getPermission('tasks') === constants.permissions.WRITE && (
              <>
                <Button
                  label="Add New Stage"
                  icon="pi pi-plus"
                  className="p-button p-button-primary outline ms-2"
                  style={{ borderRadius: 8, height: '40px', overflow: 'visible' }}
                  onClick={() => setShowAddStageDialog(true)}
                />
                <Button
                  label="Add New Task"
                  icon="pi pi-plus"
                  className="button p-button p-component p-button p-button-primary ms-2"
                  onClick={() => openAddTask()}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center mb-3 justify-content-between flex-wrap">
        <Filter currentView={currentView} setCurrentView={setCurrentView} />
      </div>

      {/* Add New Stage Dialog */}
      <AddNewStage visible={showAddStageDialog} onHide={() => setShowAddStageDialog(false)} />
    </React.Fragment>
  );
}

// Memoize to prevent unnecessary rerenders
export default React.memo(Header);
